import {$, w} from './constants';
import './menu';
import './sliders';
import './planes';
import { initYT } from'./youtube-lazy-load';

gsap.registerPlugin(ScrollTrigger);
//Timelines para animaciones
const submenu_tl = gsap.timeline();
const hero = gsap.timeline();
const banner = gsap.timeline();
const grid = gsap.timeline();
const grid_block = gsap.timeline();
const blocks_tl = gsap.timeline();
const vertical = gsap.timeline();
const blog_tl = gsap.timeline();

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
	
	
	$('.btn-filter').click(function(){
		$('.btn-filter').removeClass('active');
		$(this).addClass('active');
		$.ajax({
	           type: 'POST',
	           dataType: 'html',
	           url: cltvo_js_vars.ajax_url,
	           data: { action: 'filter_client', term_id: $(this).data('term') },
	           success: function(data){
	           		$('#clients-snippet').html( data );
	           		$( '.animation-grid-block' ).css( 'opacity', 1 );
	           },
		       error: function(errors){
		       		console.log( errors );
		       }
		    });

	});

	$('.btn-filter-faqs').click(function(){
		$('.btn-filter-faqs').removeClass('active');
		$(this).addClass('active');
		$.ajax({
	           type: 'POST',
	           dataType: 'html',
	           url: cltvo_js_vars.ajax_url,
	           data: { action: 'filter_question', term_id: $(this).data('term') },
	           success: function(data){
	           		$('#questions-snippet').html( data );
	           },
		       error: function(errors){
		       		console.log( errors );
		       }
		    });

	});

	$('.btn-filter-tutorials').click(function(){
		$('.btn-filter-tutorials').removeClass('active');
		$(this).addClass('active');
		$.ajax({
	           type: 'POST',
	           dataType: 'html',
	           url: cltvo_js_vars.ajax_url,
	           data: { action: 'filter_tutorial', term_id: $(this).data('term') },
	           success: function(data){
	           		$('#tutorials-snippet').html( data );
					initYT();
					$( '.animation-grid-block' ).css( 'opacity', 1 );
	           },
		       error: function(errors){
		       		console.log( errors );
		       }
		    });
		});


	$('.select-updates').on( 'change', function(){

		let year = $( '#year-update' ).val();
		let term = $( '#term-update' ).val();

		call_updated_posts( year, term );
	});

	//Posicionamiento y seleccion de las actualizaciones
	if( window.location.pathname.indexOf('actualizaciones-parrotconnect') !== -1 && window.location.search !== '' ){
		
		let search  = window.location.search.substr(1).split('=')[1];
		let options = [];
		let term = null;

		$( '#term-update > option' ).each(function(){
			if( this.value != '' && this.dataset.type == search ){
				this.selected = true;
				term = this.value;
			}
		});

		call_updated_posts( null, term );

		$([document.documentElement, document.body]).animate({
	        scrollTop: $("#grid-updates").offset().top
	    }, 1500);

	}

	//Faqs
	let lastItem;
	$('body').on('click', '.title--dropdown', function(){
		if($(this).parent().attr('data-state') === "open"){
			$(this).parent().data('state', 'close');
			$(this).parent().attr('data-state', 'close');
			$(this).children('.button--plus').removeClass('show');
			$(this).siblings('.content--dropdown').slideUp('fast');
		}else{
			lastItem = $('.faqs__questions').find("[data-state = 'open']");
			$(lastItem).data('state', 'close');
			$(lastItem).attr('data-state', 'close');
			$(lastItem).children('.title--dropdown').find('.button--plus').removeClass('show');
			$(lastItem).children('.content--dropdown').slideUp('fast');
			$(this).parent().data('state', 'open');
			$(this).parent().attr('data-state', 'open');
			$(this).children('.button--plus').addClass('show');
			$(this).siblings('.content--dropdown').slideToggle('slow');
		}
	});

	
	//Bloques en banner
	const getBlocksHidden = () =>{

		gsap.set('.block-1', {y:50, opacity: 0});
		gsap.set('.block-2', {y:40, opacity: 0});
		gsap.set('.block-3', {y: 40, opacity: 0});
		
		ScrollTrigger.batch(".animation-banner-block", {
			onEnter: batch => {
				console.log(batch);
				gsap.to(batch, {stagger: {each: 0.15, grid: [1, 3]}})
				batch.forEach((card) => gsap.to(card.children, { opacity: 1, y: 0, stagger: {each: 0.10, grid: [1, 3]}, duration: 1,  overwrite: true }))
			},
			once: true
		});
		ScrollTrigger.addEventListener("refreshInit", () => gsap.set("block", {y: 0, scale: 1, opacity: 1}));
	}

	//Bloques en grid
	const getBatchBlocks = () => {
		gsap.defaults({ease: "power3.out"});
		gsap.set(".animation-grid-block", {y: 75, opacity: 0, scale: 0.9});
		ScrollTrigger.batch(".animation-grid-block", {
			onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, scale: 1, stagger: {each: 0.15, grid: [1, 4]}, duration: .5, overwrite: true}),
			//onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
			once: true
		});
		
		ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-grid-block", {y: 0, scale: 1, opacity: 1}));
	}

	const getBatchBlocksDesktop = () => {
		gsap.defaults({ease: "power3.out"});
		gsap.set(".animation-grid-block-desktop", {y: 75, opacity: 0, scale: 0.9});
		ScrollTrigger.batch(".animation-grid-block-desktop", {
			onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, scale: 1, stagger: {each: 0.15, grid: [1, 4]}, duration: .5, overwrite: true}),
			//onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
			once: true
		});
		
		ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-grid-block-desktop", {y: 0, scale: 1, opacity: 1}));
	}

	//Bloques en lista
	const getBlocksList = () =>{
		let blocks= gsap.utils.toArray('.animation-blocks-single');
		blocks.forEach((block, i) => {
			grid_block.fromTo(block, {
				duration: 1,
				opacity: 0,
				ease: 'power3.out'
			},{
				scrollTrigger : {
					trigger: block,
					scrub: true,
					start: "start-=100 50%",
					end: "bottom-=100 50%",
					markers : false,
					once: true
				},
				opacity: 1,
			})
		});
		return grid_block;
	}

	//Bloques slider
	const getBlocks = () =>{
		gsap.set(".slider-home__block", {y: 100, opacity: 0});
		let panels = gsap.utils.toArray('.slider-home__block');
		panels.forEach((block, i) => {
			grid_block.fromTo(block, {
				duration: .5,
				y: 100,
				opacity: 0,
				ease: 'power3.out'
			},{
				scrollTrigger : {
					trigger: block,
					scrub: true,
					start: "start-=200 50%",
					end: "bottom-=200 50%",
					markers : false
				},
				y: 0,
				opacity: 1,
			})
		});
	}

	const getBlocksClass = () =>{
		gsap.set(".slider-home__block", {y: 100});
		let panels = gsap.utils.toArray('.slider-home__block');
		panels.forEach((block, i) => {
			grid_block.fromTo(block, {
				y: 100,
				ease: 'power3.out'
			},{
				scrollTrigger : {
					trigger: block,
					scrub: true,
					start: "start 50%",
					end: "bottom 50%",
					markers : false,
					onEnter: () =>{
						$(block).addClass('active');
					},
					onLeave : () =>{
						$(block).removeClass('active');
					},
					onToggle : () =>{
						$(block).toggleClass('active');
					}
				},
				y: 0,
			})
		});
		//ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-grid-block", {y: 0}));
	}

	//Bloques slider móvil
	const getBlocksMobile = () =>{
		gsap.set(".slider-home__block", {y: 100, opacity: 0});
		let panels = gsap.utils.toArray('.slider-home__block');
		panels.forEach((block, i) => {
			grid_block.fromTo(block, {
				duration: 3,
				y: 70,
				opacity: 0.5,
				ease: 'power3.out'
			},{
				scrollTrigger : {
					trigger: block,
					scrub: true,
					start: "start-=150 50%",
					end: "bottom-=150 50%",
					markers : false
				},
				y: 0,
				opacity: 1,
			})
		});
	}
	

	ScrollTrigger.matchMedia({
	
        // desktop
        "(min-width: 901px)": function() {

			if( $('.slider-home').length ){
				
				vertical.to('.slider-home', {
					scrollTrigger : {
						trigger: ".slider-home",
						scrub: true,
						start : "start-=60",
						end : "bottom 50%",
						markers : false,
						invalidateOnRefresh: true
					}
				}).call(getBlocksClass);
			}

			if($('.functions-connect__nav').length){
				submenu_tl.to('.functions-connect__nav', {
					scrollTrigger : {
						trigger: ".functions-list",
						scrub: true,
						start : "-=190",
						end: "bottom",
						//endTrigger: '.main-wrap',
						markers : false,
						onEnter: () =>{
							$('.logo-connect').addClass('active');
							$('.functions-connect__nav').addClass('fixed');
							$('.submenu-fixer').addClass('active');
							$('.header--with-submenu').addClass('hide');
						},
						onLeave : () =>{
							$('.logo-connect').removeClass('active');
							$('.functions-connect__nav').removeClass('fixed');
							$('.submenu-fixer').removeClass('active');
							$('.header--with-submenu').removeClass('hide');
						},
						onToggle : () =>{
							$('.logo-connect').toggleClass('active');
							$('.functions-connect__nav').toggleClass('fixed');
							$('.submenu-fixer').toggleClass('active');
							$('.header--with-submenu').toggleClass('hide');
						}

					}
				})
				gsap.utils.toArray('.section-pointer').forEach((panel) => {
					let id = panel.getAttribute('id');
					submenu_tl.to(`#${id}`,{
						scrollTrigger : {
							trigger: `#${id}`,
							scrub: true,
							start : "-=90",
							end : "bottom-=90",
							toggleActions : "restart pause resume pause",
							markers: false,
							repeat: 1,
							onEnter : () => {
								$('.functions-connect__nav-container').find(`a[href="#${id}"`).addClass('active');
							},
							onLeave : () => {
								$('.functions-connect__nav-container').find(`a[href="#${id}"`).removeClass('active');
								$(panel).removeClass('fadeIn');
							},
							onToggle : () => {
								$('.functions-connect__nav-container').find(`a[href="#${id}"`).toggleClass('active');
										
							}
						},
					})
				})
			}
			//Animación grid sólo desktop
			if( $('.animation-grid-desktop').length){
				grid.to('.animation-grid-desktop', {
					scrollTrigger : {
						trigger: ".animation-grid-desktop",
						scrub: true,
						start : "start-=400",
						end : `bottom+=300 50%`,
						markers : false
					}
				}).call(getBatchBlocksDesktop);
			}
        },
      
        // Tablets
        "(min-width: 651px) and (max-width: 900px)": function() {

			if( $('.slider-home').length ){
				
				vertical.to('.slider-home', {
					scrollTrigger : {
						trigger: ".slider-home",
						scrub: true,
						start : "start-=60",
						end : "bottom 50%",
						markers : false,
						onEnter: () =>{
							$('.slider-home__left').addClass('fix');
							$('.fixer-title').addClass('active');
						},
						onToggle : () =>{
							$('.slider-home__left').toggleClass('fix');
							$('.fixer-title').toggleClass('active');
						},
						onLeave : () =>{
							$('.slider-home__left').removeClass('fix');
							$('.fixer-title').removeClass('active');
						},
						onEnterBack : ()=>{
							$('.slider-home__left').addClass('fix');
							$('.fixer-title').addClass('active');
						},
						invalidateOnRefresh: true
					}
				}).call(getBlocksClass);
			}

			//Toggle para FAQs
			$('.faqs__block').click(function(){
				$(this).siblings('.faqs__block').removeClass('show');
				$(this).toggleClass('show');
			})

			//Sidebar en single blog
			if($('#sticky-bar').length){
				gsap.to('#sticky-bar', {
					scrollTrigger : {
						trigger: ".single-blog__content",
						scrub: true,
						start : "start-=60",
						end : "bottom 50%",
						markers : false,
						onToggle : () =>{
							$('#sticky-bar').removeClass('fixed');
						},
						onLeave : () =>{
							$('#sticky-bar').addClass('fixed');
						},
						onEnterBack : ()=>{
							$('#sticky-bar').removeClass('fixed');
						},
					}
				})
			}

			
        },
		"(max-width: 650px)": function() {

			if( $('.slider-home').length ){
				
				vertical.to('.slider-home', {
					scrollTrigger : {
						trigger: ".slider-home",
						scrub: true,
						start : "start-=60",
						end : "bottom 50%",
						markers : false,
						onEnter: () =>{
							$('.slider-home__left').addClass('fix');
							$('.fixer-title').addClass('active');
						},
						onToggle : () =>{
							$('.slider-home__left').toggleClass('fix');
							$('.fixer-title').toggleClass('active');
						},
						onLeave : () =>{
							$('.slider-home__left').removeClass('fix');
							$('.fixer-title').removeClass('active');
						},
						onEnterBack : ()=>{
							$('.slider-home__left').addClass('fix');
							$('.fixer-title').addClass('active');
						},
						invalidateOnRefresh: true
					}
				}).call(getBlocksMobile);
			}

			//Toggle para FAQs
			$('.faqs__block').click(function(){
				$(this).siblings('.faqs__block').removeClass('show');
				$(this).toggleClass('show');
			})

			//Sidebar en single blog
			if($('#sticky-bar').length){
				gsap.to('#sticky-bar', {
					scrollTrigger : {
						trigger: ".single-blog__content",
						scrub: true,
						start : "start-=60",
						end : "bottom 50%",
						markers : false,
						onToggle : () =>{
							$('#sticky-bar').removeClass('fixed');
						},
						onLeave : () =>{
							$('#sticky-bar').addClass('fixed');
						},
						onEnterBack : ()=>{
							$('#sticky-bar').removeClass('fixed');
						},
					}
				})
			}
        },
          
        // all 
        "all": function() {

			//Se oculta/muestra logo menú
			if($('#logo-blog-main').length){
				blog_tl.to('#logo-blog-main', {
					scrollTrigger : {
						trigger: "#logo-blog-trigger",
						scrub: true,
						start : "start",
						end : `bottom 50%`,
						markers : false,
						onToggle : () =>{
							$('#logo-blog-main').removeClass('reveal');
						},
						onLeave : () =>{
							$('#logo-blog-main').addClass('reveal');
						},
						onEnterBack : ()=>{
							$('#logo-blog-main').removeClass('reveal');
						},
					}
				})
			}
			//Animación banner
			if( $('.animation-banner').length){
				banner.to('.animation-banner', {
					scrollTrigger : {
						trigger: ".animation-banner",
						scrub: true,
						start : "start-=200",
						end : `bottom 50%`,
						markers : false,
						invalidateOnRefresh: true
					}
				}).call(getBlocksHidden);
			}

			//Animación grid
			if( $('.animation-grid').length){
				grid.to('.animation-grid', {
					scrollTrigger : {
						trigger: ".animation-grid",
						scrub: true,
						start : "start-=400",
						end : `bottom+=300 50%`,
						markers : false
					}
				}).call(getBatchBlocks);
			}

			//Animación bloques
			if( $('.animation-blocks').length){
				blocks_tl.to('.animation-blocks',{
					scrollTrigger : {
						trigger: ".animation-blocks",
						scrub: true,
						start : "start-=200",
						end : `bottom 50%`,
						markers : false,
						once: true
					}
				}).call(getBlocksList);
			}

			//Animación contenido básico
			if( $('.animation-content').length){

				gsap.utils.toArray('.animation-content').forEach((block, index) =>{
					console.log(block);
					gsap.set('.block-1', {y:100, opacity: 0});
					gsap.set('.block-2', {y:150, opacity: 0});
					gsap.set('.block-3', {y:150, opacity: 0});
					ScrollTrigger.batch(".animation-content-block", {
						trigger: ".animation-content",
						scrub: true,
						start : `start-=200`,
						end : `bottom 50%`,
						markers : false,
						onEnter: batch => {
							console.log(batch);
							gsap.to(batch, {stagger: {each: 0.15, grid: [1, 2]}})
							batch.forEach((card) => gsap.to(card.children, { opacity: 1, y: 0, stagger: {each: 0.10, grid: [1, 2]}, duration: 1,  overwrite: true }))
						},
						once: true
					});
			
					ScrollTrigger.addEventListener("refreshInit", () => gsap.set("block", {y: 0, scale: 1, opacity: 1}));
				})
			}
		}
	});
	
	
});

/* window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}); */

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

	//Títulos en banner

	const getStagedTitles = () =>{
		gsap.defaults({ease: "power3.out"});
		gsap.set(".animation-title-block", {y: 100, opacity: 0});
		ScrollTrigger.batch(".animation-title-block", {
			onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.10, grid: [1, 3]}, duration: 1, overwrite: true}),
			//onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
			once: true
		});
			
		ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-title-block", {y: 0, opacity: 1}));
	}


	//Animación en hero

	if($('.animation-title').length){
		hero.to('.animation-title', {
			scrollTrigger : {
				trigger: ".animation-title",
				scrub: true, 
				start : "start-=100",
				end : `bottom 50%`,
				markers : false,
				invalidateOnRefresh: true
			}
		}).call(getStagedTitles);
	}

	//Cookies
    if(localStorage.getItem('parrot_cookie')){
        $('#cookie-parrot').addClass('hide');
    }else{
        $('#cookie-parrot').delay(900).addClass('show');
        $('#ok-cookie').click(() => {
            localStorage.setItem('parrot_cookie', 'true');
            $('#cookie-parrot').addClass('hide');
            console.log('Acepto cookies')
        })
    }

	//Formulario de contacto
	$('.input-val').on('blur', function() {
        if ($("#contact").valid()) {
            $('#submit').prop('disabled', false);  
        } else {
            $('#submit').prop('disabled', 'disabled');
        }
    });

    $("#contact").validate({
        rules: {
            name : {
                required: true
            },
            phone_number: {
                required: true,
                number: true
            },
            email: {
                required: true,
                email: true
            },
            company: {
                required: true,
            }
        },
        messages : {
            name: {
                required: ""
            },
            phone_number: {
                required: "",
                number: "Por favor ingrese solo números"
            },
            email: {
                required: "",
                email: "Ingresa una dirección de correo válida"
            },
            company: {
                required: ""
            }
        },
        errorClass : "error-contact",
        errorElement: "label",
        submitHandler: function(form) {
            event.preventDefault();
            $('#submit').prop('disabled', true);
			
            $.ajax({
                url: cltvo_js_vars.ajax_url,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    $('#name').val('');
                    $('#phone_number').val('');
                    $('#email').val('');
                    $('#company').val('');
                    $('#submit').prop('disabled', true);
                    $('#success').html('Gracias por tu interés en Parrot, tus datos se enviaron con éxito. Uno de nuestros ejecutivos se pondrá en contacto contigo.');
                }
            });
        }
    });

    $( '#show-more' ).on('click', function() {
    	$( '#more-elements' ).removeClass('hide');
    	$( this ).addClass('hide');
    });

	let flag = false;
	//Toggle Planes
	$('#table-trigger').click(function(){
		$(this).toggleClass('show');
		$('#table-plans').toggleClass('show');

		if (flag == false ) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#table-plans").offset().top - 81
			}, 500);
		}

		flag = !flag;
	});

	$('#table-trigger-mobile').click(function(){
		$(this).toggleClass('show');
		$('#table-plans-mobile').toggleClass('show');

		if (flag == false ) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#table-plans-mobile").offset().top - 81
			}, 500);
		}

		flag = !flag;
	});

	//FAQS Planes

	$('.tab-trigger').click(function(){
		$('.tab-trigger').removeClass('active');
		$(this).addClass('active');
		let data = $(this).data('block');
		let active = $('.plans-questions__tabs-container').find(`.plans-questions__tabs-block[data-block="${data}"]`);
		$('.plans-questions__tabs-container').find('.plans-questions__tabs-block.active').removeClass('active');
		$(active).addClass('active');
	})

	//Lista planes
	$('.trigger-plan-nav').click(function(){
		$('.trigger-plan-nav').removeClass('active');
		$(this).addClass('active');
		let data = $(this).data('plan-tab');
		let active = $('.plans-card__table-tabs').find(`.plans-card__table-tabs-block[data-plan-tab="${data}"]`);
		$('.plans-card__table-tabs').find('.plans-card__table-tabs-block.active').removeClass('active');
		$(active).addClass('active');
		$([document.documentElement, document.body]).animate({
			scrollTop: $(active).offset().top - 81
		}, 10);
	})
	
})

function call_updated_posts( year, term ){
	$.ajax({
       	type: 'POST',
       	dataType: 'html',
       	url: cltvo_js_vars.ajax_url,
       	data: { 
       		action : 'filter_update', 
       		year   : year, 
       		term_id: term 
       	},
       	success: function(data){
       		$('#updates-snippet').html( data );
       		$( '.animation-grid-block' ).css( 'opacity', 1 );
       	},
       	error: function(errors){
       		console.log( errors );
       	}
	});
}

document.addEventListener("DOMContentLoaded", function() {
	if($('#tutorials-trigger')){
		initYT();
	}
});